/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* Eclipse CRO Signature — retour au dernier parcours d'achat. */
(function(){
  'use strict';
  var storageKey='eclLastShoppingPath';
  function isValid(path){
    if(!path||path.charAt(0)!=='/'||path.slice(0,2)==='//'||path.includes('\\'))return false;
    var parts=path.toLowerCase().split('/').filter(Boolean);
    var forbidden=['cart','checkout','checkouts','account','admin','apps','challenge','policies','search'];
    if(parts.some(function(p){return forbidden.indexOf(p)!==-1;}))return false;
    return !(parts.indexOf('collections')!==-1 && parts.indexOf('all')!==-1);
  }
  function normalized(url){
    try{var u=new URL(url,window.location.origin);if(u.origin!==window.location.origin)return '';
      return isValid(u.pathname)?u.pathname+u.search:'';
    }catch(e){return '';}
  }
  var current=window.location.pathname+window.location.search;
  if(isValid(window.location.pathname)){
    try{sessionStorage.setItem(storageKey,current);}catch(e){}
  }
  if(window.location.pathname.toLowerCase().split('/').filter(Boolean).indexOf('cart')===-1)return;
  document.addEventListener('click',function(event){
    var a=event.target.closest('[data-ecl-return-shopping]');
    if(!a)return;
    var ref=normalized(document.referrer);
    var saved='';try{saved=normalized(sessionStorage.getItem(storageKey)||'');}catch(e){}
    var fallback=a.getAttribute('href')||'/';
    var target=ref||saved||fallback;
    if(!target||!isValid(new URL(target,location.origin).pathname))target=fallback;
    a.setAttribute('href',target);
  },true);
})();
